module.exports = __webpack_public_path__ + "img/robot.5ccb4786.png";